import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import { Skeleton } from "primereact/skeleton";
import NoRequestsFound from "./NoRequestsFound";
import { Avatar } from "primereact/avatar";
import { Link } from "react-router-dom";
import { REQUEST_TYPES } from "../useRequest";

import { format } from "date-fns";
import { getStatusOptions, StatusKey } from "~/utils/status";
const RequestDataTable = ({
  requests,
  isDataAvailable,
  totalRecords,
  page,
  rows,
  onPageChange,
  loading,
  setShowModal,
  requestType,
}) => {
  const skeletonRows = [...Array(5)];
  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0]?.charAt(0) || "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const statusOption = getStatusOptions([
    StatusKey.IN_PROGRESS,
    StatusKey.COMPLETED,
    StatusKey.OVERDUE,
    StatusKey.NOT_NEEDED,
    StatusKey.NOT_STARTED,
  ]);
  const getStatus = (code) => {
    return statusOption.find((data) => data?.code === code);
  };

  const renderIdColumn = (
    <Column
      header={
        requestType === REQUEST_TYPES.AD_HOC ? "Request ID" : "Escalation ID"
      }
      body={(data) =>
        loading ? (
          <Skeleton width="100%" />
        ) : (
          <Link
            className="entity-link"
            to={`/${requestType === REQUEST_TYPES.AD_HOC ? "requests" : "escalations"}/${data.id}/conversation`}
          >
            {data.request_id}
          </Link>
        )
      }
    />
  );

  const renderUserColumn = (columnHeader, userDataKey) => (
    <Column
      header={columnHeader}
      className="user__role--col"
      style={{ minWidth: "164px" }}
      body={(data) => {
        const userData = data?.[userDataKey];
        return loading ? (
          <Skeleton width="100%" />
        ) : (
          <div className="flex align-items-center gap-1">
            <Avatar
              shape="circle"
              image={userData?.profile_picture}
              label={
                !userData?.profile_picture
                  ? getInitials(
                      [userData?.first_name, userData?.last_name]
                        .filter(Boolean)
                        .join(" "),
                    )
                  : undefined
              }
            />
            <span>
              {userData?.first_name} {userData?.last_name}
            </span>
          </div>
        );
      }}
    />
  );

  return (
    <div>
      {isDataAvailable ? (
        <DataTable
          value={loading ? skeletonRows : requests}
          className="datatable-right-align"
          lazy
          paginator={totalRecords > 10}
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          onPage={onPageChange}
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No user found"
        >
          {renderIdColumn}
          {requestType === REQUEST_TYPES.AD_HOC && (
            <Column
              header="Type"
              body={(data) =>
                loading ? <Skeleton width="100%" /> : data.reason
              }
            />
          )}
          <Column
            header="Entity"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <Link
                  className="request__link"
                  to={`/entity/${data.entityData?.id}/dashboard`}
                >
                  {data.entityData?.name} ({data.entityData?.country})
                </Link>
              )
            }
          />
          {requestType === REQUEST_TYPES.ESCALATION && (
            <Column
              header="Process"
              body={(data) =>
                loading ? (
                  <Skeleton width="100%" />
                ) : (
                  <>
                    {data.processData && (
                      <Link
                        className="request__link"
                        to={`/process/${data.processData?.id}/milestones`}
                      >
                        {data.processData?.name}
                      </Link>
                    )}
                    {data.custom_process_name && (
                      <span className="custom-process-name">
                        {data.custom_process_name}
                      </span>
                    )}
                  </>
                )
              }
            />
          )}
          {requestType === REQUEST_TYPES.ESCALATION &&
            renderUserColumn("Escalated By", "createdByData")}
          <Column
            header="Status"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="flex align-items-center">
                  <span
                    className="status__dot"
                    style={{
                      backgroundColor: getStatus(data.status).primary_color,
                    }}
                  ></span>
                  <span>{getStatus(data.status).name}</span>
                </div>
              )
            }
          />
          {requestType === REQUEST_TYPES.AD_HOC &&
            renderUserColumn("Assignee", "assigneeData")}
          {requestType === REQUEST_TYPES.AD_HOC &&
            renderUserColumn("Submitted By", "createdByData")}
          <Column
            header="Submitted"
            className="user__role--col"
            style={{ minWidth: "164px" }}
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                format(data.createdAt, "MMMM do, yyyy")
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <NoRequestsFound
            setShowModal={setShowModal}
            requestType={requestType}
            heading={
              requestType === REQUEST_TYPES.AD_HOC
                ? "No Requests found."
                : "No Escalations Found"
            }
            description={
              requestType === REQUEST_TYPES.AD_HOC
                ? "You have no pending requests at the moment."
                : "You have no pending escalations at the moment."
            }
          />
        </div>
      )}
    </div>
  );
};

export default RequestDataTable;
